import { useEffect } from 'react';
import { FilterItem } from '@components/filter/FilterStyle';
import theme from '@theme/index';
import styled from 'styled-components';

/**
 * InputFilter - 텍스트 입력 필터 컴포넌트
 *
 * @param title - 필터 타이틀
 * @param placeholder - 플레이스홀더 텍스트
 * @param input - 입력 값
 * @param setInput - 입력 값 변경 함수
 * @param initialValue - 초기값 (필터 초기화 시 사용)
 */

const StyledInput = styled.input`
  width: 100%;
  margin: 0;
  padding: 0.5rem;
  border: 1px solid ${theme.neutralGray[200]};
  border-radius: 4px;
  background: ${theme.white};
  font-size: 0.875rem;
  color: ${theme.neutralGray[600]};

  &::placeholder {
    color: ${theme.neutralGray[300]};
  }

  &:focus {
    outline: none;
    border-color: ${theme.primary};
  }

  &:disabled {
    background: ${theme.neutralGray[100]};
    color: ${theme.neutralGray[400]};
    cursor: not-allowed;
  }
`;

interface Props {
  title: string;
  placeholder?: string;
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
  initialValue?: string;
  description?: string;
}

interface FilterProps {
  placeholder?: string;
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
}

const FilterItemInput = ({ placeholder, input, setInput }: FilterProps) => {
  return (
    <StyledInput
      type="text"
      placeholder={placeholder || ''}
      value={input}
      onChange={(e) => setInput(e.target.value)}
    />
  );
};

const InputFilter = ({
  title,
  initialValue = '',
  placeholder,
  input,
  setInput,
  description,
}: Props) => {
  // CustomEvent 기반 필터 초기화 리스너
  useEffect(() => {
    const handleReset = () => {
      setInput(initialValue);
    };

    window.addEventListener('reset-filter', handleReset);
    return () => window.removeEventListener('reset-filter', handleReset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  return (
    <FilterItem
      title={title}
      description={description}
      content={<FilterItemInput placeholder={placeholder} input={input} setInput={setInput} />}
    />
  );
};

export default InputFilter;
